/* eslint-disable indent */
import React, { useContext } from 'react';
import { WidgetPrintHeader, NoRecordsPrintDiv } from '@mummssoftware/common-ui';
import { FlexColumnDiv } from '@mummssoftware/common-ui/style';
import { Orders, Notes, Both } from '@mummssoftware/utils/constants';
import { checkTrue } from '@mummssoftware/utils/utils';
import { Context } from '../../context';
import NotesListPrint from './NotesListPrint';
import { ProgressNotesPrintDiv, PageBreak } from './StyledDiv';
import defaults from '../../translations/en.json';

type ProgressNotesPrintProps = {
  progressNotes?: mumms.progressNotebyEntity[];
};

const texts: NonNullable<mumms.JSONObject> = defaults;

export const ProgressNotePrint = (props: ProgressNotesPrintProps) => {
  const { progressNotes, printConfig, idgMeetingId, idgData } = useContext(
    Context,
  );
  let printPN;
  let printTitle;
  let isCombined;

  if (printConfig?.view) {
    const config = Array.isArray(printConfig.view)
      ? printConfig.view[0]
      : printConfig.view;

    if (config === Both) {
      const ordersPrintPN = progressNotes.filter((x) => checkTrue(x.isorder));
      const notesPrintPN = progressNotes.filter((x) => !checkTrue(x.isorder));
      printPN = { orders: ordersPrintPN, notes: notesPrintPN };
      printTitle = texts.generalPrintTitle;
      isCombined = true;
    } else if (config === Orders) {
      printPN = progressNotes.filter((x) => checkTrue(x.isorder));
      printTitle = texts.ordersPrintTitle;
      isCombined = false;
    } else if (config === Notes) {
      printPN = progressNotes.filter((x) => !checkTrue(x.isorder));
      printTitle = texts.notesPrintTitle;
      isCombined = false;
    }
  } else {
    printTitle = texts.generalPrintTitle;
    printPN = progressNotes;
    isCombined = !!idgData;
  }
  return (
    <FlexColumnDiv>
      <WidgetPrintHeader title={printTitle as string} />
      {printPN && printPN?.length ? (
        <ProgressNotesPrintDiv>
          <NotesListPrint
            isCombined={isCombined}
            notes={printPN}
            isIDG={!!idgData}
          />
        </ProgressNotesPrintDiv>
      ) : (
        <NoRecordsPrintDiv>
          <p> {texts.noProgressNotesDateRange}</p>
        </NoRecordsPrintDiv>
      )}
      <PageBreak />
    </FlexColumnDiv>
  );
};

export default ProgressNotePrint;
